import React from 'react'
import * as css from 'styles'
import styled from 'react-emotion'

import Circle from '../images/icon-circle.svg';
import Triangle from '../images/icon-triangle.svg';

// const Icon = ({ type, style, flip }) => {
//   const types = {
//     circle: Circle,
//     triangle: Triangle,
//   }
//   return (
//     <img
//     src={types[type]}
//     alt=""
//     style={{
//       ...style, 
//       height: '0.75rem',
//       transform: flip ? 'scaleX(-1)' : 'none',
//     }}
//     />
//   )
// }

const Icon = ({ type, style, color = css.color.black, rotate }) => {
  const iconStyle = {
    height: '0.775rem',
    transform: rotate ? `rotate(${rotate}deg)` : 'none',
    transition: css.transition.fast,
    '& path, & g':{
      transition: css.transition.fast,
    },
    ...style,
  }
  const icons = {
    circle: (
      <svg style={iconStyle} viewBox="0 0 15 15">
        <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
          <g id="Rendered" transform="translate(-32.000000, 0.000000)" fill={color} fillRule="nonzero">
            <path d="M39.5,15 C43.6421356,15 47,11.6421356 47,7.5 C47,3.35786438 43.6421356,0 39.5,0 C35.3578644,0 32,3.35786438 32,7.5 C32,11.6421356 35.3578644,15 39.5,15 Z M39.5,12.5 C36.7385763,12.5 34.5,10.2614237 34.5,7.5 C34.5,4.73857625 36.7385763,2.5 39.5,2.5 C42.2614237,2.5 44.5,4.73857625 44.5,7.5 C44.5,10.2614237 42.2614237,12.5 39.5,12.5 Z" id="Oval"></path>
          </g>
        </g>
      </svg>
    ),
    triangle: (
      <svg style={iconStyle} viewBox="0 0 15 15">
        <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
          <g id="Rendered" fill={color} fillRule="nonzero">
            <path d="M15,0 L15,15 L0,7.5 L15,0 Z M5.59016994,7.5 L12.5,10.954915 L12.5,4.04508497 L5.59016994,7.5 Z" id="Triangle"></path>
          </g>
        </g>
      </svg>
    ),
  }
  return (
    <span>{icons[type]}</span>
  )
  // return (
  //   <img
  //     src={types[type]}
  //     alt=""
  //     style={{
  //       ...style,
  //       height: '0.75rem',
  //       transform: flip ? 'scaleX(-1)' : 'none',
  //     }}
  //   />
  // )
}

export default Icon;


// WEBPACK FOOTER //
// ./src/containers/Icon.js